// saga.js
import { all, takeEvery, put } from 'redux-saga/effects';
import SuperFetch from '@iso/lib/helpers/superFetch';

import teamActions from './actions';

const DEFAULT_QUERY = {
  limit: 10,
  skip: 0,
  populate: [],
  sort: '_id',
  direction: 'desc',
};

function* getTeams({ payload }) {
  try {
    const response = yield SuperFetch.get('/teams', {
      ...DEFAULT_QUERY,
      ...payload,
    });

    yield put(teamActions.setTeams({
      data: response.data,
      total: response.total,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
    }));
  } catch (err) {
    yield put({
      type: teamActions.TEAM_ERROR,
      payload: err.message,
    });
  }
}

function* getTeam({ payload }) {
  try {
    console.log('Saga getTeam called with payload:', payload);
    const response = yield SuperFetch.get(`/teams/${payload}`);
    console.log('Saga getTeam response:', response);
    yield put(teamActions.setTeam(response));
  } catch (err) {
    console.error('Saga getTeam error:', err);
    yield put({
      type: teamActions.TEAM_ERROR,
      payload: err.message,
    });
  }
}

function* createOrUpdateTeam({ payload }) {
  try {
    const { id, ...restBody } = payload;
    if (!id) {
      // Create one
      const team = yield SuperFetch.post('/teams', payload);
      return yield put(teamActions.createTeam(team));
    }

    // Update existed one
    const team = yield SuperFetch.put(`/teams/${payload.id}`, restBody);
    return yield put(teamActions.updateTeam(team));
  } catch (err) {
    yield put({
      type: teamActions.TEAM_ERROR,
      payload: err.message,
    });
  }
}

function* deleteTeam({ payload }) {
  try {
    const team = yield SuperFetch.delete(`/teams/${payload.id}`);
    return yield put(teamActions.deleteTeam(team));
  } catch (err) {
    yield put({
      type: teamActions.TEAM_ERROR,
      payload: err.message,
    });
  }
}

function* getTeamCustomerStats({ payload }) {
  try {
    console.log('Calling getTeamCustomerStats API with teamId:', payload);
    const response = yield SuperFetch.get(`/teams/${payload}/reports/customers`);
    console.log('getTeamCustomerStats API response:', response);
    yield put(teamActions.setTeamCustomerStats(response));
  } catch (err) {
    console.error('getTeamCustomerStats API error:', err);
    yield put({
      type: teamActions.TEAM_ERROR,
      payload: err.message,
    });
  }
}

function* getTeamTicketStats({ payload }) {
  try {
    console.log('Calling getTeamTicketStats API with teamId:', payload);
    const response = yield SuperFetch.get(`/teams/${payload}/reports/tickets`);
    console.log('getTeamTicketStats API response:', response);
    yield put(teamActions.setTeamTicketStats(response));
  } catch (err) {
    console.error('getTeamTicketStats API error:', err);
    yield put({
      type: teamActions.TEAM_ERROR,
      payload: err.message,
    });
  }
}

function* getTeamFeedbackStats({ payload }) {
  try {
    console.log('Calling getTeamFeedbackStats API with teamId:', payload);
    const response = yield SuperFetch.get(`/teams/${payload}/reports/feedback`);
    console.log('getTeamFeedbackStats API response:', response);
    yield put(teamActions.setTeamFeedbackStats(response));
  } catch (err) {
    console.error('getTeamFeedbackStats API error:', err);
    yield put({
      type: teamActions.TEAM_ERROR,
      payload: err.message,
    });
  }
}

export default function* teamSaga() {
  yield all([
    takeEvery(teamActions.GET_TEAMS, getTeams),
    takeEvery(teamActions.GET_TEAM, getTeam),
    takeEvery(teamActions.CREATE_OR_UPDATE_TEAM_WATCHER, createOrUpdateTeam),
    takeEvery(teamActions.DELETE_TEAM_WATCHER, deleteTeam),
    takeEvery(teamActions.GET_TEAM_CUSTOMER_STATS, getTeamCustomerStats),
    takeEvery(teamActions.GET_TEAM_TICKET_STATS, getTeamTicketStats),
    takeEvery(teamActions.GET_TEAM_FEEDBACK_STATS, getTeamFeedbackStats),
  ]);
}
